<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="vertical">
          <a-row :gutter="48">
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item
                label="所属管线"
                prop="pipelineId"
              >
                <a-select
                  v-model="queryParam.pipelineId"
                  placeholder="请选择所属管线"
                  allow-clear
                  show-search
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="item in pipelineList"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.pipelineName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item
                label="故障状态"
                prop="alarmStatus"
              >
                <a-select
                  v-model="queryParam.alarmStatus"
                  placeholder="请选择故障状态"
                  allow-clear
                >
                  <a-select-option
                    :key="0"
                    :value="0"
                  >未处理</a-select-option>
                  <a-select-option
                    :key="1"
                    :value="1"
                  >已修复</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item
                label="故障类型"
                prop="alarmType"
              >
                <a-select
                  v-model="queryParam.alarmType"
                  placeholder="请选择故障类型"
                  allow-clear
                >
                  <a-select-option
                    :key="0"
                    :value="0"
                  >电池故障</a-select-option>
                  <a-select-option
                    :key="1"
                    :value="1"
                  >SIM卡故障</a-select-option>
                  <a-select-option
                    :key="2"
                    :value="2"
                  >通讯故障</a-select-option>
                  <a-select-option
                    :key="3"
                    :value="3"
                  >终端故障</a-select-option>
                  <a-select-option
                    :key="4"
                    :value="4"
                  >测量故障</a-select-option>
                  <a-select-option
                    :key="5"
                    :value="5"
                  >元件故障</a-select-option>
                  <a-select-option
                    :key="6"
                    :value="6"
                  >阴极保护电位报警</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
              v-if="advanced"
            >
              <a-form-item
                label="故障开始时间"
                prop="startTime"
              >
                <a-space
                  direction="vertical"
                  :size="12"
                >
                  <a-range-picker
                    style="width: 100%"
                    v-model="dateRange"
                    valueFormat="YYYY-MM-DD HH:mm:ss"
                    format="YYYY-MM-DD HH:mm:ss"
                    show-time
                    allow-clear
                  />
                </a-space>
              </a-form-item>
            </a-col>
            <a-col
              :md="!advanced && 6 || 24"
              :sm="24"
            >
              <span
                class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {}"
              >
                <a-button
                  type="primary"
                  @click="handleQuery"
                ><a-icon type="search" />查询</a-button>
                <a-button
                  style="margin-left: 8px"
                  @click="resetQuery"
                ><a-icon type="redo" />重置</a-button>
                <a
                  @click="toggleAdvanced"
                  style="margin-left: 8px"
                >
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 4350, y: 3000 }"
      >
        <span
          slot="index"
          slot-scope="text, record, index"
        >
          {{ ((queryParam.pageNum - 1) * queryParam.pageSize) + (index + 1) }}
        </span>
        <span
          slot="riskLevel"
          slot-scope="text, record"
        >
          <a-tag
            v-if="record.riskLevel == 1"
            color="#f50"
          >高</a-tag>
          <a-tag
            v-if="record.riskLevel == 2"
            color="#2db7f5"
          >中</a-tag>
          <a-tag
            v-if="record.riskLevel == 3"
            color="#87d068"
          >低</a-tag>
        </span>
        <span
          slot="alarmType"
          slot-scope="text, record"
        >
          <span>{{ record.alarmType == 0 ? '电池故障' : record.alarmType == 1 ? 'SIM卡故障' :
            record.alarmType == 2 ? '通讯故障' : record.alarmType == 3 ? '终端故障 ' : record.alarmType == 4 ? '测量故障 ' :
              record.alarmType == 5 ? '元件故障
                      ':record.alarmType==6?'阴极保护电位报警 ':'--' }}</span>
        </span>
        <span
          slot="protectionStatus"
          slot-scope="text, record"
        >
          <a-tag
            v-if="record.protectionStatus == 0"
            color="#87d068"
          >正常</a-tag>
          <a-tag
            v-if="record.protectionStatus == 1"
            color="#2db7f5"
          >欠保护</a-tag>
          <a-tag
            v-if="record.protectionStatus == 2"
            color="#108ee9"
          >过保护</a-tag>
        </span>
        <span
          slot="alarmLevel"
          slot-scope="text, record"
        >

          <a-tag
            v-if="record.alarmLevel == 0"
            color="#108ee9"
          >预警</a-tag>
        </span>
        <span
          slot="alarmStatus"
          slot-scope="text, record"
        >

          <a-tag
            v-if="record.alarmStatus == 1"
            color="#108ee9"
          >已处理</a-tag>
          <a-tag
            v-if="record.alarmStatus == 0"
            color="red"
          >未处理</a-tag>
        </span>
        <span
          slot="analyseTime"
          slot-scope="text, record"
        >
          {{ parseTime(record.analyseTime) }}
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageDeviceAlarm, listPipeline } from '@/api/saifuneng/devicealarm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'DeviceEvaluate',
  components: {

  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pipelineList: [],
      deviceTypeList: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 日期范围
      dateRange: [],
      // 查询参数
      queryParam: {
        pipelineId: undefined,
        alarmStatus: undefined,
        alarmType: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        deviceId: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          ellipsis: true,
          align: 'center',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'index' }
        },
        // {
        //   title: '位置编号',
        //   dataIndex: 'locationDescription',
        //   ellipsis: true,
        //   align: 'center',
        //   width: 250,
        //   fixed: 'left'
        // },
        // {
        //   title: '设备类型',
        //   dataIndex: 'deviceTypeName',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '故障类型',
          dataIndex: 'alarmType',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'alarmType' }
        },
        {
          title: '故障等级',
          dataIndex: 'alarmLevel',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'alarmLevel' }
        },
        {
          title: '故障状态',
          dataIndex: 'alarmStatus',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'alarmStatus' }
        },
        {
          title: '故障原因',
          dataIndex: 'alarmReason',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '判断标准',
          dataIndex: 'judgmentCriteria',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '解决措施',
          dataIndex: 'solutionMeasures',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '故障开始时间',
        //   dataIndex: 'startTime',
        //   scopedSlots: { customRender: 'startTime' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '故障结束时间',
        //   dataIndex: 'endTime',
        //   scopedSlots: { customRender: 'endTime' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '维修时长/天',
        //   dataIndex: 'dayCount',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '设备编号',
        //   dataIndex: 'deviceCode',
        //   ellipsis: true,
        //   align: 'center'
        // }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
    this.getPipelineList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询设备信息列表 */
    getList () {
      this.loading = true
      if (this.dateRange !== null && this.dateRange !== '' && this.dateRange.length === 2) {
        this.queryParam.createBeginTime = this.dateRange[0]
        this.queryParam.createEndTime = this.dateRange[1]
      }
      pageDeviceAlarm(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.dateRange = []
      this.queryParam = {
        pipelineId: undefined,
        alarmStatus: undefined,
        alarmType: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        deviceId: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    getPipelineList () {
      listPipeline().then(response => {
        this.pipelineList = response.data
      })
    },
    getDeviceTypeList () {
      listDeviceType().then(response => {
        this.deviceTypeList = response.data
      })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    }

  }
}
</script>
